<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :action-column-props="{ width: 200 }"
    :form="form"
    :title="$t(`model.options/${routeType}`)"
    resource="options"
    :onFetchData="onFetchData"
    :before-submit="beforeSubmit"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/options.js';
import _ from 'lodash';

@Component
export default class Options extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  get routeType() {
    return _.get(this.$route, 'params.type')
  }

  get stiType() {
    return `Options::${_.startCase(this.routeType)}`
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'name_cont',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'name',
      {
        key: 'position',
        width: 180,
        sortable: true,
      },
      this.stiType === 'Options::Style' && 'cover',
      'prompt',
      'guidance_scale',
      'negative_prompt',
      {
        key: 'created_at',
        width: 180,
        sortable: true,
      },
      type === 'show' && {
        key: 'creator',
        width: 180,
        renderCell: (h, { props: { scope: { row } } }) => {
          const value = row.creator
          const name = value.cn === 'User' ? 'users.show' : 'admin_users_roles.show'
          const displayName = value.cn === 'User' ? value.screen_name : value.admin_user.name || value.admin_user.email
          return <bean-link keepNode to={{ name: name, params: { id: value.id } }}>{displayName}</bean-link>
        }
      },
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'name',
      {
        key: 'position',
        renderCell: {
          hint: this.$t('hint.positionColumn'),
        },
      },
      this.stiType === 'Options::Style' && {
        key: 'cover',
        renderCell: {
          required: true,
        },
      },
      {
        key: 'prompt',
        renderCell: {
          hint: '关键词用逗号分隔',
        }
      },
      {
        key: 'guidance_scale',
        renderCell: {
          component: 'input',
          hint: '引导强度, 生成的图像与输入提示的紧密程度与输入的多样性之间的权衡度，取值1-30，默认值13',
          props: { type: 'number' }
        }
      },
      {
        key: 'negative_prompt',
        renderCell: {
          hint: '关键词用逗号分隔',
        }
      }
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'options.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'options.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  async onFetchData({ type }) {
    if (type === 'index') {
      const { data, pagination } = await this.$request.get('/options', { params: { ...this.$route.query, type_eq: this.stiType } });
      return {
        data,
        pagination
      }
    }

    if (type === 'show' || type === 'edit') {
      const data = await this.$request.get(`/options/${this.$route.params.id}`);
      return { data };
    }

    if (type === 'new') {
      return {
        type: this.stiType
      }
    }
  }

  beforeSubmit({ state: { data } }) {
    return { ...data, type: this.stiType };
  }
}

export const route = [
  {
    path: '/options/:type',
    name: 'options.index',
    component: Options,
    props: {
      type: 'index',
    }
  },
  {
    path: '/options/:type/new',
    name: 'options.new',
    component: Options,
    props: {
      type: 'new',
    }
  },
  {
    path: '/options/:type/:id',
    name: 'options.show',
    component: Options,
    props: {
      type: 'show',
    }
  },
  {
    path: '/options/:type/:id/edit',
    name: 'options.edit',
    component: Options,
    props: {
      type: 'edit'
    }
  }
]
</script>
